import React from 'react';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

import 'vdp-used/components/PhotosAndBodyAndCertifiedSection/AsTraded/AsTraded.scss';

const AsTraded = () => {
    const asTradedTextCZ = ContentZonesService.getContentZone('widget.vdp.used', 'widget.vdp.used.as.traded.text');
    const asTradedImageCZ = ContentZonesService.getContentZone(
        'widget.vdp.used.similar.cars',
        'widget.vdp.used.similar.cars.as.traded.img'
    );

    const shouldDisplayAsTradedBadgeCZ = ContentZonesService.getContentZone(
        'widget.vdp.used.similar.cars',
        'widget.vdp.used.similar.cars.should.display.as.traded.badge'
    );

    const shouldDisplayAsTradedBadge = shouldDisplayAsTradedBadgeCZ && shouldDisplayAsTradedBadgeCZ.getValue();

    const asTradedImage = asTradedImageCZ &&
        asTradedImageCZ.getValue() && (
            <div className="as-traded-logo">
                <img className="custom-as-traded-logo" src={asTradedImageCZ.getValue()} alt="AsTraded" />
            </div>
        );

    return (
        shouldDisplayAsTradedBadge === 'true' &&
        !!asTradedImage && (
            <div className="showroom-vdp-used-as-traded-zone">
                {asTradedImage}
                <div className="as-traded-list">
                    <div className="as-traded-title">{LocaleService.t('VDP_USED.ASTRADED.TITLE')}</div>
                    <p className="as-traded-text is-light">
                        {(asTradedTextCZ && asTradedTextCZ.getValue()) ||
                            LocaleService.t('VDP_USED.ASTRADED.DESCRIPTION')}
                    </p>
                </div>
            </div>
        )
    );
};

AsTraded.displayName = 'AsTraded';

export default AsTraded;
